// odemelerService.ts
import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";  
import { API_URL } from "../../constants/API_URL"; 
import { OdemelerRaporuRequestModal } from "../../types/RequestModals/OdemelerRaporuRequestModal";
import { OdemelerRaporuResponseModal } from "../../types/modals";
import { OdemelerError } from "../../types/ErrorModals/OdemelerError";

export const getOdemelerRaporu = async (request: OdemelerRaporuRequestModal): Promise<OdemelerRaporuResponseModal> => {
  try {
    const response = await axios.post<ApiResponse<OdemelerRaporuResponseModal>>(
      `${API_URL}/api/Odemeler/getOdemelerRaporu`,
      request
    );
    
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Ödeme verileri bulunamadı",
          correlationId: responseData?.correlationId
        } as OdemelerError;
      }
      
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as OdemelerError;
      }
      
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as OdemelerError;
    }
    
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as OdemelerError;
  }
};